import gql from "graphql-tag";

const getLandingTitle = gql`
  query GetLandingTitle($businessUnitInput: BusinessUnitInput!, $path: String) {
    landing(businessUnitInput: $businessUnitInput, path: $path) {
      metaTitle
      metaDescription
      title
      description
      noIndex
    }
  }
`;

export { getLandingTitle };
